import React, { useEffect, useState } from 'react';
import './scss/deposit.scss';
import FullScreenLoader from './full-screen';
import DepositTransactionProp from './properties/deposit-transaction-prop';
import Api from '../services/api';
import SelectBlockchain from './select-blockchains';

function DepositForm({ setStatusMessage }: DepositTransactionProp): React.ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorClass, setSetErrorClass] = useState('hide');
  const [depositAddress, setDepositAddress] = useState('');
  const [txHash, setTxHash] = useState('');
  const [blockchain, setBlockchain] = useState('');

  function validateForm(): boolean {
    if (!depositAddress || (depositAddress && depositAddress.trim().length === 0)) {
      setErrorMessage('Please enter deposit address');
      setSetErrorClass('error mb-4');
      return false;
    }

    if (!txHash || (txHash && txHash.trim().length === 0)) {
      setErrorMessage('Please enter tx hash');
      setSetErrorClass('error mb-4');
      return false;
    }

    if (!blockchain || (blockchain && blockchain.trim().length === 0)) {
      setErrorMessage('Blockchain not set');
      setSetErrorClass('error mb-4');
      return false;
    }

    setErrorMessage('');
    setSetErrorClass('hide');
    return true;
  }

  function resetForm() {
    setBlockchain('');
    setDepositAddress('');
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      Api.startDeposit(depositAddress, txHash, blockchain).then((result) => {
        if (result.error) {
          if (result.error.message?.refund?.length > 0) {
            setStatusMessage(result.error.message?.refund.toString(), 'error');
          } else {
            setStatusMessage(result.error.message, 'error');
          }
        } else {
          setStatusMessage('Deposit Success', 'success');
        }
        setIsLoading(false);
        window.scrollTo(0, 0);
        resetForm();
      }).catch((error) => {
        setStatusMessage(error.message, 'error');
        setIsLoading(false);
        window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {

  }, []);

  return (
    <div className="rounded collection-add mb-5 loading-wrapper">
      {isLoading ? <FullScreenLoader /> : <div />}
      <h4 className="pb-3">Deposit</h4>
      <p>Start deposit process for a given deposit address </p>
      <form onSubmit={handleSubmit}>
        <div className={errorClass}>{errorMessage}</div>
        <div className="mb-3">
          <p className="mb-2 text-form-label">Blockchain</p>
          <div className="mt-0 mb-3">
            <SelectBlockchain
                balor={true}
              onLoading={() => { setIsLoading(true); }}
              onLoaded={() => { setIsLoading(false); }}
              onChange={(data) => { setBlockchain(data); }}
              setStatusMessage={setStatusMessage}
            />
          </div>
          <label htmlFor="name" className="form-label">
            Deposit Address
            <input
              type="text"
              id="name"
              className="form-control"
              value={depositAddress}
              onChange={(e) => setDepositAddress(e.target.value)}
            />
          </label>
          <label htmlFor="txHash" className="form-label">
            Tx Hash
            <input
              type="text"
              id="txHash"
              className="form-control"
              value={txHash}
              onChange={(e) => setTxHash(e.target.value)}
            />
          </label>
        </div>
        <button type="submit" className="btn btn-dark">Deposit</button>
      </form>
    </div>
  );
}

export default DepositForm;
